module.exports = __webpack_public_path__ + "img/prepaid.8f94825d.png";